import axiosLib from "axios";

const rawBase = (process.env.REACT_APP_BASE_URL || "").trim().replace(/\/+$/, "");
const baseURL = rawBase ? `${rawBase}/config` : "/config";

const axios = axiosLib.create({
    baseURL,
});

axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

export default axios;
